import type { SupportedCurrency } from '#src/__generated__/globalTypes.ts';
import { FiatCurrency } from '#src/__generated__/globalTypes.ts';
import type { IconDefinition } from '#src/atoms/icons/index.tsx';
import { iconDollar } from '#src/atoms/icons/system/iconDollar.ts';
import { iconEuro } from '#src/atoms/icons/system/iconEuro.ts';
import { iconSterlingSign } from '#src/atoms/icons/system/iconSterlingSign.ts';

export const fiatCurrencySymbols: Record<FiatCurrency, string> = {
  [FiatCurrency.EUR]: '€',
  [FiatCurrency.GBP]: '£',
  [FiatCurrency.USD]: '$',
};

export const faFiatCurrencySymbols: Record<FiatCurrency, IconDefinition> = {
  [FiatCurrency.EUR]: iconEuro,
  [FiatCurrency.GBP]: iconSterlingSign,
  [FiatCurrency.USD]: iconDollar,
};

export const isFiatCurrency = (
  value: SupportedCurrency
): value is FiatCurrency => {
  return Object.values(FiatCurrency).includesValue(value);
};

export const findFiatWallet = <
  T extends { publicInfo: { currency?: FiatCurrency | null } },
>(
  fiatWallets: readonly T[],
  fiatCurrency: FiatCurrency
): T | undefined =>
  fiatWallets.find(wallet => wallet.publicInfo.currency === fiatCurrency) ??
  fiatWallets[0];
